"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var FormField = function FormField(props) {
  var children = props.children,
      help = props.help,
      error = props.error,
      className = props.className;

  var renderHelp = function renderHelp() {
    var hasErrorMessage = error && error !== true;

    if (!hasErrorMessage && !help) {
      return null;
    }

    var _className = (0, _classnames.default)('FormField__help', {
      'FormField__help--error': hasErrorMessage
    });

    return React.createElement("div", {
      className: _className
    }, hasErrorMessage ? error : help);
  };

  var _className = (0, _classnames.default)(className, 'FormField', {
    'FormField--error': !!error
  });

  return React.createElement("div", {
    className: _className
  }, React.createElement("div", {
    className: "FormField__input"
  }, children), renderHelp());
};

FormField.displayName = 'Form.Field';
FormField.defaultProps = {
  help: undefined,
  error: undefined,
  className: undefined
};
var _default = FormField;
exports.default = _default;